import React from 'react';

export default function SectionContainer({ className = '', children }) {
  return <section className={`cc-tonal-panel p-4 md:p-5 ${className}`}>{children}</section>;
}
